export enum ContractTabsEnum {
  GENERAL = 'general',
  ESTIMATE_ITEM_POSITIONS = 'estimateItemInvoiceTabTitle',
}
